module.exports = __webpack_public_path__ + "media/images/amenities_icons/dart-1bb9b114ac3a4bdaaf4447072f96586c.svg";